import { render } from "./CreateSubLocationModal.vue?vue&type=template&id=4741585d&scoped=true"
import script from "./CreateSubLocationModal.vue?vue&type=script&lang=js"
export * from "./CreateSubLocationModal.vue?vue&type=script&lang=js"

import "./CreateSubLocationModal.vue?vue&type=style&index=0&id=4741585d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4741585d"]])

export default __exports__